export default "__VITE_ASSET__DK6aKVgL__"